import { Component, Inject, NgZone,Type  } from '@angular/core';
import { Platform, NavController, ModalController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { authenticationService } from './Services/Authentication/authentication.service';
import { NavigationEnd, NavigationStart, Router ,Event,} from '@angular/router';
import { Camera, PictureSourceType } from '@ionic-native/camera/ngx';
import { CameraService } from './Services/Media/camera.service';
import { SqlitebaseService } from './Services/Sqlite/Sqlitebase.service';
import { TranslateService } from '@ngx-translate/core';
import { APP_CONFIG, AppConfig } from './app.config';
import { MyEvent } from 'src/services/myevent.services';
import { Constants } from 'src/models/contants.models';
import { NotificationService } from './Services/Notifications/notification.service';
import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic/ngx';
import { INotificationPayload } from 'cordova-plugin-fcm-with-dependecy-updated';
import { Storage } from '@ionic/storage';
import { BackgroundMode,BackgroundModeConfiguration } from '@ionic-native/background-mode/ngx';
//import { AppVersion } from '@ionic-native/app-version/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  rtlSide = "left";
  selectedIndex: any;
  appPages: any;

  public token: string;
  public pushPayload: INotificationPayload;
  constructor(
    @Inject(APP_CONFIG) public config: AppConfig,
   private platform: Platform,
   private splashScreen: SplashScreen,
   private statusBar: StatusBar ,
   private auth: authenticationService,
   private router:Router,private ngzone:NgZone ,
   private sql:SqlitebaseService,private navCtrl: NavController,
   private translate: TranslateService,
   private myEvent: MyEvent,
   private _serviceNotify: NotificationService,
   private fcm: FCM,
   private backgroundMode: BackgroundMode

  ) {
  
    // this.myEvent.getLanguageObservable().subscribe(value => {
    //   this.navCtrl.navigateRoot(['./']);
    //   //this.globalize(value);
    // });
  
    
    this.auth.chekMiseAjourVersion()
    this.initializeApp()
  }
 
  globalize(languagePriority) {
    this.translate.setDefaultLang("en");
    let defaultLangCode = this.config.availableLanguages[0].code;
    this.translate.use(languagePriority && languagePriority.length ? languagePriority : defaultLangCode);
    this.setDirectionAccordingly(languagePriority && languagePriority.length ? languagePriority : defaultLangCode);
  }

  setDirectionAccordingly(lang: string) {
    switch (lang) {
      case 'ar': {
        this.rtlSide = "rtl";
        break;
      }
      default: {
        this.rtlSide = "ltr";
        break;
      }
    }
  }

  initializeApp() {
    // check if user are authenticated
    this.navCtrl.navigateRoot(['menu'])
    //this.ngzone.run(() =>   this.navCtrl.navigateRoot(['menu']));
  
    this.platform.ready().then(() => {     
      this.statusBar.backgroundColorByHexString("#000b30");
     //this.ngzone.run(() =>   this.router.navigateByUrl('/menu'));

      //this.statusBar.styleDefault();
     // this.splashScreen.hide()
    // this.backgroundMode.on
     // this.backgroundMode.enable()
    // const conf:BackgroundModeConfiguration={
    //     title:"je suis en back"
    // }
    // this.backgroundMode.configure(conf)
    // this.backgroundMode.setEnabled(true)
    // this.backgroundMode.on("").subscribe(
      
    // )
    
        if (this.platform.is("cordova")) {
         // this.statusBar.styleDefault();
           //this.statusBar.styleBlackTranslucent()
          // this.statusBar.overlaysWebView(true);
  

         

          // window.powerManagement.dim(function() {
          //   console.log('Wakelock acquired');
          // }, function() {
          //   console.log('Failed to acquire wakelock');
          // });
          // window.powerManagement.setReleaseOnPause(false, function() {
          //   console.log('setReleaseOnPause successfully');
          // }, function() {
          //   console.log('Failed to set');
          // });
          


           this.sql.createDB()
           this.sql.getDatabaseState().subscribe(
            res =>{
              if (res) {
                
                this._serviceNotify.goAtMidnight();
      
              }
  
            }
          )
          this.statusBar.backgroundColorByHexString('#516e8e');
         // this.setupFCM()
  
          //this.statusBar.backgroundColorByHexString('#106bec')
        }
       
  
      });
  
  }

  public get pushPayloadString() {
    return JSON.stringify(this.pushPayload, null, 4);
  }
  ngOnInit() {

  }
}
